export default function append(first, second) {
    first.push.apply(first, second);
    return first;
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/util/append.js